<div class="raw main">
    <div class="col-12">
        <div class="col-6 right">
            <div class="signup animated fadeIn" *ngIf="contacts">
                <h1>申請報名</h1>

                <h3 *ngIf="SelectedTime">洽談日期與時段</h3>
                <div class="form" *ngIf="SelectedTime">
                    <span>{{SelectedTime.sessionTime.desc}}</span>
                    <label class="change">
                        <a href="javascript:void(0)" (click)="ChangeTime()">變更洽談時段</a>
                    </label>
                </div>

                <h3>報名人資訊</h3>
                <div class="form">
                    <p class="roles">
                        請注意：<br/>
                        1. 若需修改「報名人」聯絡資訊請至會員中心調整。<br/>
                        2. 若需修改「參加人」聯絡資訊請洽活動承辦單位。<br/>
                        3. 可於承辦單位審核完成前，自行於「我的預約」中更換參加人。
                    </p>
                    <label>報名人：</label>
                    <p class="contact" *ngIf="user">
                        <span *ngIf="Company">{{Company}}</span>
                        <span>{{user.name}} {{user.englishName}}</span>
                        <span>{{user.mobile}}</span>
                        <span>{{user.email}}</span>
                        <span>{{user.tel}}</span>
                        <span></span>
                    </p>
                </div>
                

                <h3>參加人資訊</h3>
                <div class="form">
                    <p class="msg">
                        1.若下方預帶非參加人姓名，請從下拉式選單選取更換，若選單無姓名，請選「新增參加人資訊」<br/><br/>
                        2.請勿使用共用業務帳號報名，以免核對上造成問題，若需更換參加者可於「我的預約」下拉更換或通知活動承辦人
                    </p>

                    <select (change)="SetUser($event)" id="contactUser">
                        <ng-container *ngFor="let use of contacts;let _index = index;">
                            <option value="{{_index}}">{{use.name}} {{use.englishName}}</option>
                        </ng-container>
                        <option value="add">新增參加人資訊</option>
                    </select>
                    <!-- <span class="edit" *ngIf="IsEdit == false" (click)="Edit()">新增參加人資訊</span> -->
                    <!-- <span class="edit" *ngIf="IsEdit == true" (click)="CancelEdit()">取消新增參加人資訊</span> -->
                   
                    <!-- <p class="contact" *ngIf="IsEdit == false">
                        <span>{{user.name}} {{user.englishName}}</span>
                        <span>{{user.mobile}}</span>
                        <span>{{user.email}}</span>
                        <span>{{user.tel}}</span>
                    </p> -->
                    <ng-container *ngIf="IsEdit">
                        <h3>新增參加人資訊</h3>
                        <form [formGroup]="mainForm">
                            <div class="form">
                                <div class="form-group">
                                    <label class="require">參加人中文姓名</label>
                                    <input type="tel" formControlName="name" placeholder="請輸入參加人中文姓名" maxlength="50"/>
                                    <span class="help-block" *ngIf="!(mainForm.get('name').valid || mainForm.get('name').pristine)">
                                        必填，限50字以內
                                    </span>
                                    <!-- <span class="readonly">{{mainForm.value['name']}}</span> -->
                                </div>
                                <div class="form-group">
                                    <label class="require">參加人英文姓名</label>
                                    <input type="tel" formControlName="englishName" placeholder="請輸入參加人英文姓名" maxlength="50"/>
                                    <span class="help-block" *ngIf="!(mainForm.get('englishName').valid || mainForm.get('englishName').pristine)">
                                        必填，限50字以內
                                    </span>
                                    <!-- <span class="readonly">{{mainForm.value['englishName']}}</span> -->
                                </div>
                                <div class="form-group">
                                    <label class="require">參加人 Email</label>
                                    <input type="tel" formControlName="email" placeholder="請輸入參加人Email" maxlength="150" [email]="true" />
                                    <span class="help-block" *ngIf="!(mainForm.get('email').valid || mainForm.get('email').pristine)">
                                        必填，限150字以內
                                    </span>
                                    <!-- <span class="readonly">{{mainForm.value['email']}}</span> -->
                                </div>
                                <div class="form-group">
                                    <label class="require">參加人手機</label>
                                    <input type="tel" formControlName="mobile" placeholder="請輸入參加人手機" maxlength="10"/>
                                    <span class="help-block" *ngIf="!(mainForm.get('mobile').valid || mainForm.get('mobile').pristine)">
                                        必填，限10字以內
                                    </span>
                                </div>
                                <div class="form-group">
                                    <label class="require">公司電話</label>
                                    <input type="tel" formControlName="tel" placeholder="請輸入參加人公司電話" maxlength="30"/>
                                    <span class="help-block" *ngIf="!(mainForm.get('tel').valid || mainForm.get('tel').pristine)">
                                        必填，限30字以內
                                    </span>
                                </div>
                            </div>
                        </form>
                    </ng-container>
                </div>

                <h3 *ngIf="formSet">公司資訊</h3>
                <div class="form">
                    <form id="extra">
                        <ng-container *ngFor="let item of formSet">
                            <div class="form-group" *ngIf="item.column_type == 'textbox'">
                                <label class="require">{{item.name}}</label>
                                <input type="text" name="{{item.id}}" placeholder="請輸入{{item.name}}" 
                                [attr.maxlength]="item.maxCharacter > 0 ? item.maxCharacter : null"
                                [attr.required]="item.required" autocomplete="off" (keyup)="CheckInput($event)" 
                                />
                                <span *ngIf="item.required" class="help-block" style="display: none;">{{item.name}}為必填</span>
                            </div>
                            <div class="form-group" *ngIf="item.column_type == 'radiobox'">
                                <label class="{{item.required ? 'require' : ''}}">{{item.name}}</label>
                                <select name="{{item.id}}">
                                    <ng-container *ngFor="let opt of item.options">
                                        <option value="{{opt.value}}">{{opt.label}}</option>
                                    </ng-container>
                                </select>
                            </div>
                            <div class="form-group" *ngIf="item.column_type == 'checkbox'">
                                <label class="{{item.required ? 'require' : ''}}">{{item.name}}</label>
                                <div class="checklist">
                                    <ng-container *ngFor="let opt of item.options;let _c = index;" >
                                        <div class="item">
                                            <input type="checkbox" name="{{item.id}}" id="{{item.id}}_{{_c}}" value="{{opt.value}}" (change)="CheckChecked($event)"/>
                                            <label for="{{item.id}}_{{_c}}">{{opt.label}}</label>
                                        </div>
                                    </ng-container>
                                </div>
                                <span *ngIf="item.required" class="help-block"  style="bottom: 2rem;display: none;">{{item.name}}為必填</span>
                            </div>
                            <div class="form-group" *ngIf="item.column_type == 'textarea'">
                                <label class="require">{{item.name}}</label>
                                <textarea name="{{item.id}}" style="resize: vertical" 
                                [attr.maxlength]="item.maxCharacter > 0 ? item.maxCharacter : null"
                                [attr.required]="item.required" 
                                (keyup)="CheckTextArea($event)"></textarea>
                                <span class="count">0/{{item.maxCharacter}}</span>
                                <span *ngIf="item.required" class="help-block" style="bottom: 1.75rem;display: none;">{{item.name}}為必填，限{{item.maxCharacter}}字以內</span>
                            </div>
                        </ng-container>
                    </form>
                </div>

                <!-- <h3>公司資訊</h3>
                <div class="form">
                    <label class="require">主要產品(中文)</label>
                    <textarea></textarea>
                    <span class="count">40/500</span>

                    <label class="require">主要產品(英文)</label>
                    <textarea></textarea>
                    <span class="count">40/500</span>
                </div> -->
                
                

                <div class="role">
                    <input type="checkbox" [(ngModel)]="roleValid" id="c0"/>
                    <label for="c0">本人同意以下 2 項：</label>
                    <p>
                        1.  本人為個資當事人，聲明已詳閱外貿協會之「個人資料保護聲明」，就告知內容充分知悉及同意。<br/>
                        2.  每場次活動結束後，本公司同意配合填寫相關問卷，以提供意見供外貿協會據以增進日後辦理活動之品質。
                    </p>
                </div>
                <div class="btn" (click)="FormSubmit()">確認送出</div>
            </div>
            
            <eventCard *ngIf="DataReady" [BuyerData]="BData" [EventData]="EData"></eventCard>
        </div>
    </div>
</div>